import {
  data as nPages,
} from '@lba-dev/package.local-globals/nPages';

import {
  AgentTabs as agentTabs,
  MapCalls,
  InterventionService,
  StatsServices,
} from '../views/agents';

export default ({ pages }) =>
  ([
    { path: '/', component: InterventionService },
    { path: '/services', component: InterventionService },
    { path: '/map', component: MapCalls },
    { path: '/statistiques', component: StatsServices },
  ].map((e) => ({ ...e, component: agentTabs(e.component) }))
    .filter((e) =>
      pages.some((a) => {
        const { route, alias } = nPages.find((p) => p._id === a.id) || {};
        return (
          (((route && e.path.includes(route)) ||
            (alias && alias.some((p) => e.path.includes(p)))) &&
            a.enable) ||
          ['/', '/faq', '/sign/:type', '/profile', '.well-known'].includes(
            e.path
          )
        );
      })
    )
    .reduce((v, c) => [...v, c, ...(c.routes || [])], []));
